export interface ProblemResult<ExtraInfoType> {
    type: string;
    title: string;
    extrainfo: ExtraInfoType;
}

/**
 * TypeGuard to check if some value is a ProblemResult
 * @param object the value to check
 * @returns Whether this object is a problemresult of any type
 */
export function IsProblemResult(object: any): object is ProblemResult<any> {
    if (object == null) return false;
    if (typeof object !== "object") return false;

    if (!("type" in object)) return false;
    if (!(typeof object.type === "string")) return false;
    if (!(object.type as string).startsWith("https://iprova.nl/probs/")) return false;

    if (!("title" in object)) return false;
    if (!(typeof object.title === "string")) return false;

    //extrainfo is optional, so no check for that property

    return true;
}

export type CancelableDebouncedFunction = { cancel: () => void };

export class Debouncer {
    /**
     * Gets wrapper for given function to prevent multiple executions when called within the set timeout
     * @param this the 'this' to use as context for func
     * @param func the function to call when the wait is over
     * @param wait time to wait in milliseconds before executing the given function
     * @returns function wrapper
     */
    public static debounce<F extends Function, T extends any>(this: T, func: F, wait: number): F & CancelableDebouncedFunction {
        let timeout: number;
        const fnc = (function (this: any, ...args: any[]): void {
            clearTimeout(timeout);
            const context: any = this;
            timeout = setTimeout(async () => {
                await func.apply(context, args);
            }, wait);
        } as Function) as F & CancelableDebouncedFunction;

        fnc.cancel = function (): void {
            clearTimeout(timeout);
        };

        return fnc;
    }
}

export interface UserSelectorFilterOptions {
    users_in_user_group: boolean;
    manager: boolean;
    organization_unit: boolean;
    position: boolean;
}

export type ProblemType = "badrequest" | "notfound" | "forbidden" | "unauthorized";
export interface ProblemResult<ExtraInfoType> {
    type: string;
    title: string;
    extrainfo: ExtraInfoType;
}
